<div class="col">
  <div class="title" l10nTranslate>shared.issueTitle</div>
  <div class="desc">
    {{ ticketDetail.title }}
  </div>
</div>
<div class="col">
  <div class="title" l10nTranslate>shared.issueDescription</div>
  <div>
    <div class="desc">
      {{ ticketDesc }}
      <div>
        <strong>URL: </strong>
        <a [routerLink]="miqUrl" [innerHTML]="ticketWebLink"></a>
      </div>
    </div>
  </div>
</div>
